import React from 'react';
import { Dropdown, Icon } from 'semantic-ui-react';
import { FormattedMessage } from 'react-intl';
import urls, { relativeUrl } from '@/constants/urls';

const AdminThemeMenu = ({ allowThemes, allowVocabularies }) => (
  <>
    {allowThemes && (
      <Dropdown.Item as="a" href={`#${relativeUrl(urls.THEMES)}`} selected={false}>
        <Icon name="paint brush" className="primary" />
        <FormattedMessage id="admin.header.menu.themes" />
      </Dropdown.Item>
    )}
    {allowVocabularies && (
      <Dropdown.Item as="a" href={`#${relativeUrl(urls.VOCABULARIES)}`} selected={false}>
        <Icon name="font" className="primary" />
        <FormattedMessage id="admin.header.menu.vocabularies" />
      </Dropdown.Item>
    )}
  </>
);

export default AdminThemeMenu;
